@let menuRows = rows();

<ng-template #projected><ng-content /></ng-template>

<ng-template #groupTitle let-row let-titleClass="titleClass">
  <div role="presentation" [class]="titleClass">
    <span class="min-w-0 truncate">{{ row.titleKey | mlTranslate: row.titleParams }}</span>
    @if (row.actionLabelKey && row.actionValue) {
      <button
        type="button"
        class="text-body-small text-primary-500 ml-auto inline-flex shrink-0 items-center gap-0.5 normal-case"
        (click)="onTitleAction(row.actionValue, $event)"
      >
        {{ row.actionLabelKey | mlTranslate: row.actionLabelParams }}
        @if (row.actionIcon; as icon) {
          <ml-icon [name]="icon" size="sm" aria-hidden="true" />
        }
      </button>
    }
  </div>
</ng-template>

<ng-template #itemContent let-item let-trailing="trailing">
  @if (item.icon; as icon) {
    <ml-icon [name]="icon" />
  }
  <span class="flex min-w-0 flex-auto flex-col">
    <span [class]="labelClass" [class.font-semibold]="item.descriptionKey || item.description">
      {{ item.labelKey || item.label | mlTranslate }}
    </span>
    @if (item.descriptionKey || item.description) {
      <span class="text-caption text-neutral-300">{{ item.descriptionKey || item.description | mlTranslate }}</span>
    }
  </span>
  @if (item.trailingLabelKey) {
    <span [class]="trailing">{{ item.trailingLabelKey | mlTranslate }}</span>
  }
  @if (item.trailingIcon; as trailingIcon) {
    <ml-icon [name]="trailingIcon" />
  }
</ng-template>

<ng-template #panel>
  <div ngpMenu [class]="panelClass()">
    <ng-container [ngTemplateOutlet]="projected" />
    @for (row of menuRows; track row.id) {
      @switch (row.kind) {
        @case ('separator') {
          <div role="separator" [class]="separatorClass"></div>
        }
        @case ('title') {
          <ng-container
            [ngTemplateOutlet]="groupTitle"
            [ngTemplateOutletContext]="{ $implicit: row, titleClass: panelGroupTitleClass }"
          />
        }
        @default {
          <button
            type="button"
            ngpMenuItem
            [ngpMenuItemDisabled]="row.item.disabled ?? false"
            [class]="itemClass({ destructive: row.item.destructive ?? false })"
            (click)="onSelect(row.item)"
          >
            <ng-container
              [ngTemplateOutlet]="itemContent"
              [ngTemplateOutletContext]="{ $implicit: row.item, trailing: panelTrailingClass }"
            />
          </button>
        }
      }
    }
  </div>
</ng-template>

@if (usesSheet()) {
  <ion-modal
    data-menu-sheet
    [isOpen]="sheetOpen()"
    [initialBreakpoint]="sheetBreakpoints.initial"
    [breakpoints]="sheetBreakpointValues"
    [handle]="true"
    (didPresent)="onSheetPresented($event)"
    (didDismiss)="closeSheet()"
  >
    <ng-template>
      <div [class]="sheetClass()" tabindex="-1" (keydown)="onSheetKeydown($event)">
        <ng-container [ngTemplateOutlet]="projected" />
        @for (row of menuRows; track row.id) {
          @switch (row.kind) {
            @case ('separator') {
              <div role="separator" [class]="separatorClass"></div>
            }
            @case ('title') {
              <ng-container
                [ngTemplateOutlet]="groupTitle"
                [ngTemplateOutletContext]="{ $implicit: row, titleClass: sheetGroupTitleClass }"
              />
            }
            @default {
              <button
                type="button"
                [disabled]="row.item.disabled ?? false"
                [class]="itemClass({ destructive: row.item.destructive ?? false, surface: 'sheet' })"
                (click)="onSelect(row.item)"
              >
                <ng-container
                  [ngTemplateOutlet]="itemContent"
                  [ngTemplateOutletContext]="{ $implicit: row.item, trailing: sheetTrailingClass }"
                />
              </button>
            }
          }
        }
      </div>
    </ng-template>
  </ion-modal>
}
